import { Message, toaster } from "rsuite";

export const toastInfo = (message = '') => {
    if (!message) {
        return;
    }

    toaster.push(
        <Message showIcon type="info">
            {message}
        </Message>,
    );
}